import { isTauri } from '@/tauri/utils';
import { isKinde, isOnPrem } from '@/utils/buildProfile';
import { type KindeState } from '@kinde-oss/kinde-auth-nextjs';
import { createContext, useContext } from 'react';

export const KindeBrowserClientContext = createContext<KindeState | null>(null);
const IS_TAURI = isTauri();

export const useKindeBrowserClientContext = () => {
  const context = useContext(KindeBrowserClientContext);

  if (context !== null) {
    return context;
  }

  // Mirrors the provider's mount gate: where no provider mounts, the absent
  // context is expected rather than a wiring bug.
  if (IS_TAURI || isOnPrem || !isKinde) {
    return null;
  }

  throw new Error(
    'KindeBrowserClientProvider is missing from the component tree. ' +
      'Wrap your component with KindeBrowserClientProvider or use the full providers path.'
  );
};
